import { Injectable } from '@angular/core';
import { XhrService } from '../../../core/services/xhr-service/xhr.service';
import { Observable } from 'rxjs';
import { API } from '../../../global/API.constants';
import { VerifyRecaptchaCodeRequestDto } from '../../interfaces/recaptcha-validation.interfaces';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaValidationService {
  constructor(private xhr: XhrService) {}

  verifyCaptcha(secret: VerifyRecaptchaCodeRequestDto): Observable<boolean> {
    return this.xhr.post(API.recaptcha.verify, secret);
  }
}
